(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('[data-shop-hub]').forEach((hub) => {
  const form = hub.querySelector('[data-shop-search-form]');
  const input = hub.querySelector('[data-shop-search-input]');
  const clearButton = hub.querySelector('[data-shop-search-clear]');
  const section = hub.closest('.catalog-page');
  const products = Array.from(section.querySelectorAll('[data-shop-product]'));
  const count = section.querySelector('[data-shop-result-count]');
  const noResults = section.querySelector('[data-shop-no-results]');
  const noResultsClear = section.querySelector('[data-shop-no-results-clear]');
  const pieceOne = hub.dataset.pieceOne;
  const pieceMany = hub.dataset.pieceMany;

  const applySearch = () => {
    const query = input.value.trim().toLowerCase();
    let visible = 0;

    products.forEach((item) => {
      const haystack = `${item.dataset.productTitle || ''} ${item.dataset.productType || ''} ${item.dataset.productTags || ''}`;
      const matches = query === '' || haystack.includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });

    count.textContent = `${visible} ${visible === 1 ? pieceOne : pieceMany}`;
    clearButton.hidden = query === '';
    noResults.hidden = visible !== 0;
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    applySearch();
  });

  input.addEventListener('input', applySearch);

  const clearSearch = () => {
    input.value = '';
    applySearch();
    input.focus();
  };

  clearButton.addEventListener('click', clearSearch);
  noResultsClear.addEventListener('click', clearSearch);
});

  } catch(e) { console.error(e); }
})();
})();
